import { MailIcon, MapPinIcon, PhoneIcon, SmartphoneIcon } from "lucide-react";

export const contactDetails = [
  { id: "address", label: "Address", value: "Plot 2419, Extension 9, Gaborone", href: null, icon: MapPinIcon },
  { id: "tel", label: "Tel/Fax", value: "Tel/Fax: 395 4047", href: "tel:+2673954047", icon: PhoneIcon },
  { id: "cell", label: "Cell", value: "Cell: +267 7165 4079", href: "tel:+26771654079", icon: SmartphoneIcon },
  {
    id: "email",
    label: "Email",
    value: "info@liftoffinvestments.co.bw",
    href: "mailto:info@liftoffinvestments.co.bw",
    icon: MailIcon,
  },
];
